export const stores = {
  all_stores: "accounts/store/",
  stores_for_map: "accounts/store/map/",
  get_one_store: (id: number) => `accounts/store/get-by/?id=${id}`,
  detele_store: (id: number) => `accounts/store/?id=${id}`,
  update_percent: (id: number) => `accounts/store/percent/?id=${id}`,
};
